export default __webpack_public_path__ + "static/media/mixkit-sport-start-bleeps-918.4d8422bc.ogg";